<template>
  <div>
    <main-header-nav :content="'组织列表'"></main-header-nav>
    <div v-loading="loading">
      <div style="width: 90%;min-width: 1024px;margin: 0px auto;">
        <el-button
          type="primary"
          v-on:click="onCreateOrgnization"
          style="width: 100px;"
          >新建组织</el-button
        >
        <el-input
          v-model="searchCondition.name"
          placeholder="组织名称"
          style="width: 150px;margin-left: calc(100% - 500px);"
        >
        </el-input>
        <el-input
          v-model="searchCondition.contact"
          placeholder="联系方式"
          style="width: 150px;margin: 0 10px;"
        >
        </el-input>
        <el-button
          type="primary"
          style="width: 80px;"
          v-on:click="requestPage(1)"
          >筛选
        </el-button>
      </div>
      <el-table
        :data="tableData"
        style="width: 90%;min-width: 1024px;margin: 10px auto;"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="150"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="contact"
          label="联系方式"
          min-width="120"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
         label="操作"
         min-width="50"
         align="center">
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small"
              >编辑
            </el-button>
            <el-button @click="freezeClick(scope.row)" type="text" size="small"
              >{{scope.row.freeze === 0 ? '冻结' : '解冻'}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px 0px 10px 0px;">
        <el-pagination
          layout="prev, pager, next, jumper"
          :page-size="pageSize"
          :total="totalSize"
          style="text-align: center;"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MainHeaderNav from '../common/MainHeaderNav'
export default {
  name: 'OrgnizationList',

  components: {
    MainHeaderNav
  },

  methods: {
    editClick (row) {
      this.$router.push(`/edit_orgnization/${row.id}`)
    },

    freezeClick (row) {
      var self = this
      this.putRequest(`/orgnizations/freeze/${row.id}`)
        .then(resp => {
          if (resp && resp.code === 200) {
            self.$message.success({ message: '操作成功' })
            self.requestPage(self.$data.searchCondition.page)
          }
        })
    },

    changePage (page) {
      this.requestPage(page)
    },

    requestPage (page) {
      var self = this
      this.$data.searchCondition.page = page
      this.$data.searchCondition.size = this.$data.pageSize
      this.$data.loading = true
      this.postRequest('/orgnizations', this.$data.searchCondition)
        .then(resp => {
          this.$data.loading = false
          if (resp && resp.result) {
            self.$data.tableData = resp.result.content
            self.$data.totalSize = resp.result.totalElements
          }
        })
    },

    onCreateOrgnization () {
      this.$router.push('/add_orgnization')
    }
  },

  data () {
    return {
      loading: false,
      tableData: [],
      totalSize: 0,
      pageSize: 10,
      searchCondition: {
        name: '',
        contact: '',
        page: 1,
        size: 10
      }
    }
  },

  mounted () {
    this.requestPage(1)
  }
}
</script>

<style scoped></style>
